import React from 'react';
import useTranslation from '../../../../../hooks/translation/useTranslation';

function ChooseSeatsNavigation({
  departureChosenSeats,
  cancelDepartureReservedSeat,
  returnChosenSeats,
  cancelReturnChosenSeats,
  showPrice,
}) {
  const { trans } = useTranslation();

  return (
    <div className="flex flex-col gap-6">
      <h3 className="hidden lg:block text-xl text-primary font-big-bold">
        {trans('chosen_tickets')}
      </h3>
      <p className="m-0 text-base font-big">
        {trans('seat')}
        {' '}
        {showPrice && (
        <>
          /
          {' '}
          {trans('price_secondary')}
        </>
        )}
      </p>
      <div className="flex gap-2 flex-wrap">
        {departureChosenSeats?.map((seat) => (
          <div
            key={`${seat?.seat_number}_${seat?.wagon_number}`}
            className="flex gap-2 justify-center items-center h-[38px] px-4 py-3 bg-gray-light-gr rounded-[19px]"
          >
            <p className="m-0 text-xl flex items-center gap-1">
              N
              {seat?.seat_number}
              {' '}
              {showPrice && (
                <>
                  -
                  {' '}
                  <span className="text-lg">
                    {seat?.initial_seat_price}
                    {trans('gel')}
                  </span>
                </>
              )}
            </p>
            <button
              type="button"
              onClick={() => cancelDepartureReservedSeat(
                { seat_number: seat?.seat_number },
                seat?.wagon_number,
              )}
              className="border-0 bg-transparent p-0"
            >
              <div className="cross" />
            </button>
          </div>
        ))}
      </div>
      {returnChosenSeats?.length > 0 && (
        <>
          <div className="h-[1px] bg-gray-semi-light-gr w-full hidden lg:block" />
          <p className="m-0 text-base font-big">
            {trans('seat')}
            {' '}
            {showPrice && (
              <>
                /
                {' '}
                {trans('price_secondary')}
              </>
            )}
          </p>
          <div className="flex gap-2 flex-wrap">
            {returnChosenSeats?.map((seat) => (
              <div
                key={`${seat?.seat_number}_${seat?.wagon_number}`}
                className="flex gap-2 justify-center items-center h-[38px] px-4 py-3 bg-gray-light-gr rounded-[19px]"
              >
                <p className="m-0 text-xl flex items-center gap-1">
                  {seat?.seat_number}
                  N
                  {' '}
                  {showPrice && (
                    <>
                      -
                      {' '}
                      <span className="text-lg">
                        {seat?.initial_seat_price}
                        {trans('gel')}
                      </span>
                    </>
                  )}
                </p>
                <button
                  type="button"
                  onClick={() => cancelReturnChosenSeats(
                    { seat_number: seat?.seat_number },
                    seat?.wagon_number,
                  )}
                  className="border-0 bg-transparent p-0"
                >
                  <div className="cross" />
                </button>
              </div>
            ))}
          </div>
        </>
      )}
      <div />
    </div>
  );
}

export default ChooseSeatsNavigation;
